export default "<div class=\"dc-cover\">\n        <img [src]=\"image\">\n</div>"